module.exports = __webpack_public_path__ + "img/3.3ac38e23.png";